<template>
  <c-modal
    v-model="modal"
    :title="'Edit Item'"
    size="xl"
    confirm-label="Save"
    cancel-label="Cancel"
    :progressing="progressing"
    @submit="submit"
    :tag="false"
    centered
    @show="createModelIn"
  >
    <template>
      <b-container fluid class="px-0">
        <b-row>
          <b-col cols="12" md="6">
            <b-form-group>
              <b-input-group :prepend="edibleType === 'Food' ? 'Food Name' : 'Drink Name'">
                <b-input
                  class="myFeild"
                  :name="edibleType === 'Food' ? 'Food Name' : 'Drink Name'"
                  v-model="model.Name"
                  placeholder="Required"
                  v-validate="'required'"
                />
              </b-input-group>
              <b-input-group v-if="menuboardAllowed" prepend="ReferenceID" class="mt-2">
                <b-input
                  class="myFeild"
                  :name="edibleType === 'Food' ? 'Food Name' : 'Drink Name'"
                  v-model="model.ReferenceID"
                  placeholder="Optional"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group v-if="AllowSecondLang" class="mb-3 mb-md-0">
              <b-input-group prepend="Second Language Name">
                <b-input class="myFeild" placeholder="Optional" v-model="model.Name_SecondLang" name="Second Language Name" />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <Mlabel v-if="kds" title="Category Name">
              {{ category.CategoryDESC }}
              
              <b-link class="ml-2" v-if="!showChangeCat" @click="changeCatVisibility()"> Edit</b-link>
              <!-- <b-input-group v-if="availableCategories.length > 0 && showChangeCat" prepend="Modifier Group" class="d-flex flex-nowrap"> -->
                <b-input-group v-if="availableCategories.length > 0 && showChangeCat" prepend="Edit Category">
                                <b-select
                                    name="category"
                                    
                                    v-model="changedCategoryID"
                                    value-field="CategoryID"
                                    text-field="CategoryDESC"
                                    :options="availableCategories"/>
                            </b-input-group>
            </Mlabel>
            <div class="d-flex flex-row justify-content-between">
              <Mlabel v-if="kds" title="Display Station">
                {{ kds }}
              </Mlabel>

              <Mlabel v-if="display" title="Printstation">
                {{ display }}
              </Mlabel>
            </div>


            <Mlabel v-if="HasTV" title="Menu Board TV Name" class="mt-2">
              {{ item.MenuboardTVName }}
              
              <b-link class="ml-2" v-if="!showChangeTV" @click="changeTVVisibility()"> Edit</b-link>
                              
                    <b-input-group prepend="Menu Board TV Name" v-if="HasTV && showChangeTV" >
                <b-form-select
                  class="myFeild"
                  v-model="selectedTV"
                  :options="TVs"
                  placeholder="Select"
                >
                  <template #first>
                    <b-form-select-option :value="null||''">Select...</b-form-select-option>
                  </template>
                </b-form-select>
              </b-input-group>
            </Mlabel>

            



          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="12">
            <b-row>
              <b-col cols="6" lg="3">
                <b-form-checkbox
                  class="my-2"
                  :disabled="model.GlutenFreeRequest"
                  v-model="model.GlutenFree"
                  @input="toggleCheckBox('gluten', model.GlutenFree)"
                  >Gluten Free</b-form-checkbox
                >
              </b-col>
              <b-col cols="6" lg="3">
                <b-form-checkbox
                  class="my-2"
                  @input="toggleCheckBox('glutenR', model.GlutenFreeRequest)"
                  :disabled="model.GlutenFree"
                  v-model="model.GlutenFreeRequest"
                  >Gluten Free Upon Request</b-form-checkbox
                >
              </b-col>
              <b-col v-if="edibleType === 'Drink'" cols="6" lg="3">
                <b-form-checkbox class="my-2" v-model="model.Alcoholic">Alcoholic</b-form-checkbox>
              </b-col>
              <b-col v-if="edibleType === 'Drink' && model.Alcoholic" cols="6" lg="3">
                <b-input-group prepend="ABV (%)">
                  <b-input
                    class="myFeild"
                    name="ABV'"
                    v-model="model.ABV"
                    type="number"
                    placeholder="Optional"
                    v-validate="'min_value: 0'"
                  />
                </b-input-group>
              </b-col>
              <template v-if="edibleType === 'Food'">
                <b-col cols="6" lg="3">
                  <b-form-checkbox
                    class="my-2"
                    @input="toggleCheckBox('vegan', model.Vegan)"
                    :disabled="model.VeganRequest"
                    v-model="model.Vegan"
                    >Vegan</b-form-checkbox
                  >
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox
                    class="my-2"
                    @input="toggleCheckBox('veganR', model.VeganRequest)"
                    :disabled="model.Vegan"
                    v-model="model.VeganRequest"
                    >Vegan Upon Request</b-form-checkbox
                  >
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox
                    class="my-2"
                    @input="toggleCheckBox('vegeterian', model.Vegeterian)"
                    :disabled="model.VegeterianRequest"
                    v-model="model.Vegeterian"
                    >Vegetarian</b-form-checkbox
                  >
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox
                    class="my-2"
                    @input="toggleCheckBox('vegeterianR', model.VegeterianRequest)"
                    :disabled="model.Vegeterian"
                    v-model="model.VegeterianRequest"
                    >Vegetarian Upon Request</b-form-checkbox
                  >
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox
                    class="my-2"
                    @input="toggleCheckBox('hot', model.Hot)"
                    :disabled="model.HotRequest"
                    v-model="model.Hot"
                    >Hot/Spicy</b-form-checkbox
                  >
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox
                    class="my-2"
                    @input="toggleCheckBox('hotR', model.HotRequest)"
                    :disabled="model.Hot"
                    v-model="model.HotRequest"
                    >Hot/Spicy Upon Request</b-form-checkbox
                  >
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox class="my-2" v-model="model.Kosher">Kosher</b-form-checkbox>
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox class="my-2" v-model="model.Halal">Halal Meat</b-form-checkbox>
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox class="my-2" v-model="model.DairyFree">Dairy Free</b-form-checkbox>
                </b-col>
                <b-col cols="6" lg="3">
                  <b-form-checkbox class="my-2" v-model="model.Uncooked">Raw/Undercooked</b-form-checkbox>
                </b-col>
              </template>
            </b-row>
          </b-col>
        </b-row>
        <hr />
        <div v-for="(item, index) in info">
          <food-info
            v-if="index === 0"
            :edibleType="edibleType"
            :AllowSecondLang="AllowSecondLang"
            :number="index + 1"
            :value="item"
          />
        </div>
        <b-collapse v-model="showMore">
          <div v-for="(item, index) in info">
            <food-info
              v-if="index !== 0"
              :edibleType="edibleType"
              :AllowSecondLang="AllowSecondLang"
              :number="index + 1"
              :value="item"
            />
          </div>
        </b-collapse>
        <section class="text-primary text-center cursor-pointer" @click="showMore = !showMore">
          <span v-if="showMore">Show less</span>
          <span v-else>Show more</span>
        </section>
        <hr />
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <b-input-group prepend="Description">
                <b-textarea class="myFeild" placeholder="Optional" v-model="model.Desc" name="Description" />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="6" class="mb-3 mb-lg-0">
            <section class="d-flex flex-row justify-content-between flex-grow-1">
              <div class="flex-grow-1 pr-3">
                <b-list-group-item
                  style="cursor:pointer;"
                  v-for="(food, index) in allFoods"
                  :key="food.ID + index + Math.random()"
                  :active="food.ID === item.ID"
                >
                  {{ food.Name }}
                </b-list-group-item>
              </div>
              <div class="d-flex flex-column">
                <b-btn class="mb-2" size="lg" @click="up">
                  <font-awesome-icon icon="caret-up" class="align-middle" />
                </b-btn>
                <b-btn @click="down" size="lg">
                  <font-awesome-icon icon="caret-down" class="align-middle" />
                </b-btn>
              </div>
            </section>
          </b-col>
          <b-col cols="12" lg="6">
            <b-form-group>
              <b-input-group prepend="Modifier Group" class="d-flex flex-nowrap">
                <Multiselect
                  class="miniMulti"
                  v-model="model.Modifiers"
                  isMultiPle
                  :options="modifiers"
                  name="item"
                  placeHolder="Select Group..."
                />
              </b-input-group>
            </b-form-group>

            <b-form-group v-if="loyaltyPermission">
              <b-input-group prepend="Loyalty Reward" class="d-flex flex-nowrap">
                <Multiselect
                  class="miniMulti"
                  :value="selectedLoyaltyRewards"
                  @input="val => selectedLoyaltyRewards = sortRewardsByStatus(val)"
                  isMultiPle
                  :options="loyaltyRewards"
                  name="loyaltyReward"
                  placeHolder="Select Reward..."
                >
                  <template v-slot:tag="{ option, remove }">
                    <span :title="option.$isDisabled ? 'Set to ' + option.scopeLabel + ', change it in Settings > Loyalty' : ''" :style="{backgroundColor: option.Status === 'active' ? '#FFC107' : '#c8ced3', borderRadius:'12px', padding:'2px 10px', marginRight:'5px', marginBottom:'5px', display:'inline-flex', alignItems:'center'}">
                      {{ option.name }}
                      <small v-if="option.$isDisabled" class="ml-1" style="opacity:.7">({{ option.scopeLabel }})</small>
                      <span v-if="!option.$isDisabled" class="ml-2 cursor-pointer" @mousedown.prevent="remove(option)"><font-awesome-icon icon="times"/></span>
                    </span>
                  </template>
                </Multiselect>
              </b-input-group>
              <small v-if="inheritedLoyaltyRewardIds.length" class="text-muted d-block mt-1">
                Locked rewards apply beyond this item. Change them in Settings &gt; Loyalty.
              </small>
            </b-form-group>

            <b-form-group>
              <b-input-group prepend="Ingredients *">
                <b-textarea class="myFeild" placeholder="Optional" v-model="model.Ingredients" name="Ingredients" />
              </b-input-group>
            </b-form-group>
            <p class="mb-0 text-danger">
              * Ingredients are NOT visible to users and are utilized for search purposes only.
            </p>
          </b-col>
          <b-col cols="12">
            <b-alert :show="errors.any()" variant="danger" class="px-4 my-2">
              <ul class="m-0 px-1">
                <li v-for="err in errors.all()" :key="err">{{ err }}</li>
              </ul>
            </b-alert>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <template #actions>
      <b-row class="flex-grow-1">
        <b-col cols="4">
          <b-btn variant="warning" block class="text-nowrap" :disabled="progressing" @click="submit">
            Save
            <font-awesome-icon v-if="progressing" spin icon="circle-notch" class="text-black align-middle mx-1" />
          </b-btn>
        </b-col>

        <b-col cols="4">
          <b-btn variant="danger" block class="text-nowrap" :disabled="progressing" @click="deleteConfirmation">
            Delete Item
          </b-btn>
        </b-col>

        <b-col cols="4">
          <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="modal = false">
            Cancel
          </b-btn>
        </b-col>
      </b-row>
    </template>
  </c-modal>
</template>

<script>
import CModal from '../../../../shared/Cmodal'
import FoodInfo from './foodInfo'
import Mlabel from '../../../../shared/Mlabel'
import Multiselect from '@/components/shared/multiselect'

export default {
  name: 'editFood',
  components: {Mlabel, FoodInfo, CModal, Multiselect},
  props: {
    value: {
      required: true,
      type: Boolean,
      default: false
    },
    category: {
      required: true,
      type: Object
    },
    updated: {
      required: false,
      type: Boolean,
      default: false
    },
    availableCategories:{
      type:Array
    },
    edibleType: {required: true},
    AllowSecondLang: {
      type: Boolean,
      default: false
    },
    item: {
      required: true,
      type: Object
    },
    foods: {
      required: true,
      type: Array,
      default: []
    },
    kds: {
      required: true,
      type: String,
      default: ''
    },
    display: {
      required: true,
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showChangeCat:false,
      showChangeTV:false,
      changedCategoryID:null,
      progressing: false,
      selectedTV:"",
      TVs:[],
      TVrereferences:[],
      selected: [], // Must be an array reference!
      modifiers: [], // Must be an array reference!
      loyaltyPermission: false,
      loyaltyRewards: [],
      loyaltyRewardsFull: [],
      selectedLoyaltyRewards: [],
      initialLoyaltyRewardIds: [],
      inheritedLoyaltyRewardIds: [],
      info: [
        {price: '', calorie: '', comment: '', secondLangComment: ''},
        {price: '', calorie: '', comment: '', secondLangComment: ''},
        {price: '', calorie: '', comment: '', secondLangComment: ''},
        {price: '', calorie: '', comment: '', secondLangComment: ''},
        {price: '', calorie: '', comment: '', secondLangComment: ''}
      ],
      showMore: false,
      model: {
        // UserID: localStorage.getItem('userID'),
        RestaurantID: this.$store.state.selectedRestaurantId,
        EdibleType: this.edibleType,
        CategoryID: this.category.CategoryID,
        Name: '',
        GlutenFree: false,
        Vegeterian: false,
        Hot: false,
        GlutenFreeRequest: false,
        HotRequest: false,
        VegeterianRequest: false,
        Kosher: false,
        Halal: false,
        Vegan: false,
        VeganRequest: false,
        Alcoholic: false,
        IsSide: false,
        DairyFree:false,
        Uncooked:false,
        Name_SecondLang: '',
        Ingredients: '',
        Desc: '',
        ABV: '',
        IsSide: 0,
        Modifiers: [],
        ReferenceID:''
      },
      allFoods: [],
      HasTV: false,
      menuboardAllowed:localStorage.getItem("hasMenuboard")
    }
  },
  watch: {
    updated(newVal) {
      if(newVal){
        let object = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        TVid:-1
    }
    this.HasTV = localStorage.getItem("hasMenuboard") === "true"
    if(this.HasTV){
      return this.$api.getRestaurant.GetRestaurantMenuboardTVs(object).then(res=>{
          if(res.success){
              this.selectedTV = ""
              this.TVs = res.menuBoards.map(tv => tv.TVname)
              this.TVrereferences = res.menuBoards

          }
          
      })
    }
      }
    }
  },
  
  methods: {
    changeCatVisibility(){
      this.changedCategoryID = this.model.CategoryID
      this.showChangeCat = !this.showChangeCat
    },
    changeTVVisibility(){
      this.showChangeTV = !this.showChangeTV
    },
    changeNegativeVal(val) {
      if (val < 0) return ''
      return val
    },
    createModelIn() {
      this.showChangeTV = false
      this.showChangeCat = false;
      this.changedCategoryID = null
      this.model.Name = this.item.Name
      this.model.ABV = this.item.ABV < 0 ? '' : this.item.ABV
      this.model.Ingredients = this.item.Ingredients
      this.model.Desc = this.item.Desc
      this.model.Name_SecondLang = this.item.Name_SecondLang
      this.model.GlutenFree = this.item.GlutenFree
      this.model.Vegeterian = this.item.Vegeterian
      this.model.Hot = this.item.Hot
      this.model.GlutenFreeRequest = this.item.GlutenFreeRequest
      this.model.HotRequest = this.item.HotRequest
      this.model.VegeterianRequest = this.item.VegeterianRequest
      this.model.Kosher = this.item.Kosher
      this.model.Halal = this.item.Halal
      this.model.Vegan = this.item.Vegan
      this.model.VeganRequest = this.item.VeganRequest
      this.model.Alcoholic = this.item.Alcoholic ? true : false
      this.model.IsSide = 0
      this.model.Uncooked = this.item.Uncooked
      this.model.DairyFree = this.item.DairyFree
      this.model.ReferenceID = this.item.ReferenceID
      const prices = [
        {
          price: this.changeNegativeVal(this.item.Price),
          calorie: this.changeNegativeVal(this.item.Calories),
          comment: this.changeNegativeVal(this.item.PriceComment),
          secondLangComment: this.changeNegativeVal(this.item.PriceComment_SecondLang)
        },
        {
          price: this.changeNegativeVal(this.item.Price1),
          calorie: this.changeNegativeVal(this.item.Calories1),
          comment: this.changeNegativeVal(this.item.Price1Comment),
          secondLangComment: this.changeNegativeVal(this.item.Price1Comment_SecondLang)
        },
        {
          price: this.changeNegativeVal(this.item.Price2),
          calorie: this.changeNegativeVal(this.item.Calories2),
          comment: this.changeNegativeVal(this.item.Price2Comment),
          secondLangComment: this.changeNegativeVal(this.item.Price2Comment_SecondLang)
        },
        {
          price: this.changeNegativeVal(this.item.Price3),
          calorie: this.changeNegativeVal(this.item.Calories3),
          comment: this.changeNegativeVal(this.item.Price3Comment),
          secondLangComment: this.changeNegativeVal(this.item.Price3Comment_SecondLang)
        },
        {
          price: this.changeNegativeVal(this.item.Price4),
          calorie: this.changeNegativeVal(this.item.Calories4),
          comment: this.changeNegativeVal(this.item.Price4Comment),
          secondLangComment: this.changeNegativeVal(this.item.Price4Comment_SecondLang)
        }
      ]
      this.info = prices
      this.allFoods = this.foods.map(item => ({...item}))
      this.allFoods.forEach((item, index) => {
        this.$set(item, 'sortOrder', index)
      })
      this.getModifierGroups()
      this.getLoyaltySettings()
    },
    getLoyaltySettings(){
      const model = {RestaurantID: Number(this.$store.state.selectedRestaurantId)}
      return this.$api.loyaltyAdmin.GetSettings(model).then(res => {
        if(res.success){
          this.loyaltyPermission = !!res.results.LoyaltyPermission
          this.loyaltyRewardsFull = res.results.Rewards || []
          this.initialLoyaltyRewardIds = this.loyaltyRewardsFull
            .filter(reward => {
              const scope = Array.isArray(reward.Scope) ? reward.Scope : []
              return scope.some(s => s.ScopeKind === 'item' && Number(s.RefID) === Number(this.item.ID) && String(s.ItemCommodity).toLowerCase() === String(this.edibleType).toLowerCase())
            })
            .map(reward => reward.RewardID)
          // rewards applied through all/menu/category scope can't be changed per item, so show them locked
          const inheritedFrom = reward => {
            const scope = Array.isArray(reward.Scope) ? reward.Scope : []
            if (!scope.length || scope.some(s => s.ScopeKind === 'all')) return 'All Menus'
            if (scope.some(s => s.ScopeKind === 'menu' && Number(s.RefID) === Number(this.category.MenuTypeID))) return 'Menu'
            if (scope.some(s => s.ScopeKind === 'category' && Number(s.RefID) === Number(this.category.CategoryID))) return 'Category'
            return ''
          }
          this.loyaltyRewards = this.sortRewardsByStatus(this.loyaltyRewardsFull.map(item => {
            const scopeLabel = inheritedFrom(item)
            return {name: item.Name, value: item.RewardID, Status: item.Status, scopeLabel, $isDisabled: !!scopeLabel}
          }))
          this.inheritedLoyaltyRewardIds = this.loyaltyRewards.filter(reward => reward.$isDisabled).map(reward => reward.value)
          this.selectedLoyaltyRewards = this.loyaltyRewards.filter(reward => this.initialLoyaltyRewardIds.includes(reward.value) || reward.$isDisabled)
        }
      })
    },
    sortRewardsByStatus(list) {
      return [...list].sort((a, b) => (a.Status === 'active' ? 0 : 1) - (b.Status === 'active' ? 0 : 1))
    },
    syncLoyaltyRewards(refId, itemCommodity, finalIds, initialIds) {
      const scopeKind = itemCommodity ? 'item' : 'category'
      const toAdd = finalIds.filter(id => !initialIds.includes(id))
      const toRemove = initialIds.filter(id => !finalIds.includes(id))
      const jobs = [...toAdd.map(id => ({id, add: true})), ...toRemove.map(id => ({id, add: false}))]
      return Promise.all(jobs.map(({id, add}) => {
        const reward = this.loyaltyRewardsFull.find(r => r.RewardID === id)
        if (!reward) return Promise.resolve()
        let scope = Array.isArray(reward.Scope) ? [...reward.Scope] : []
        const matches = s => s.ScopeKind === scopeKind && Number(s.RefID) === Number(refId) && (!itemCommodity || String(s.ItemCommodity).toLowerCase() === String(itemCommodity).toLowerCase())
        if (add) {
          if (!scope.some(matches)) {
            const entry = {ScopeKind: scopeKind, RefID: refId}
            if (itemCommodity) entry.ItemCommodity = itemCommodity
            scope.push(entry)
          }
        } else {
          scope = scope.filter(s => !matches(s))
        }
        return this.$api.loyaltyAdmin.SaveReward({
          RestaurantID: Number(this.$store.state.selectedRestaurantId),
          RewardID: reward.RewardID,
          Name: reward.Name,
          PointsThreshold: reward.PointsThreshold,
          RewardType: reward.RewardType,
          Value: reward.Value,
          Scope: scope
        })
      }))
    },
    toggleCheckBox(type, val) {
      if (type === 'gluten' && val) {
        this.model.GlutenFreeRequest = false
      }
      if (type === 'glutenR' && val) {
        this.model.GlutenFree = false
      }
      if (type === 'vegan' && val) {
        this.model.VeganRequest = false
      }
      if (type === 'veganR' && val) {
        this.model.Vegan = false
      }
      if (type === 'vegeterian' && val) {
        this.model.VegeterianRequest = false
      }
      if (type === 'vegeterianR' && val) {
        this.model.Vegeterian = false
      }
      if (type === 'hot' && val) {
        this.model.HotRequest = false
      }
      if (type === 'hotR' && val) {
        this.model.Hot = false
      }
    },
    getModifierGroups() {
      let data = {
        // UserID: localStorage.getItem('userID'),
        RestaurantID: this.$store.state.selectedRestaurantId,
        CategoryID: -1,
        ModifierType: this.edibleType === 'Food' ? 'Food' : 'Drink'
      }
      return this.$api.getRestaurant.GetRestaurantCategoryModifier(data, true).then(res => {
        if (res.success) {
          this.modifiers = res.results.RestaurantMidifierCategoriesAll
          this.modifiers.forEach(item => {
            item.value = item.ModifierCategoryID
            item.name = item.ModifierCategory
          })
          if (this.item.ModifierCategories.length) {
            this.item.ModifierCategories.forEach(item => {
              item.value = item.ModifierCategoryID
              item.name = item.ModifierCategory
            })
          }
          this.model.Modifiers = this.item.ModifierCategories
          return res.results
        } else {
        }
      })
    },
    submit() {
      this.$validator.validateAll().then(proceed => {
        const base = {...this.model}
        
        base.GlutenFree = this.$convertBoolean(base.GlutenFree)
        base.GlutenFreeRequest = this.$convertBoolean(base.GlutenFreeRequest)
        base.Vegeterian = this.$convertBoolean(base.Vegeterian)
        base.VegeterianRequest = this.$convertBoolean(base.VegeterianRequest)
        base.Hot = this.$convertBoolean(base.Hot)
        base.HotRequest = this.$convertBoolean(base.HotRequest)
        base.Kosher = this.$convertBoolean(base.Kosher)
        base.Halal = this.$convertBoolean(base.Halal)
        base.Vegan = this.$convertBoolean(base.Vegan)
        base.Alcoholic = this.$convertBoolean(base.Alcoholic)
        base.VeganRequest = this.$convertBoolean(base.VeganRequest)
        base.DairyFree = this.$convertBoolean(base.DairyFree)
        base.Uncooked = this.$convertBoolean(base.Uncooked)
        const priceInfo = {
          Price: this.info[0].price ? this.info[0].price : -1,
          Price1: this.info[1].price ? this.info[1].price : -1,
          Price2: this.info[2].price ? this.info[2].price : -1,
          Price3: this.info[3].price ? this.info[3].price : -1,
          Price4: this.info[4].price ? this.info[4].price : -1,

          PriceComment: this.info[0].comment ? this.info[0].comment : '',
          Price1Comment: this.info[1].comment ? this.info[1].comment : '',
          Price2Comment: this.info[2].comment ? this.info[2].comment : '',
          Price3Comment: this.info[3].comment ? this.info[3].comment : '',
          Price4Comment: this.info[4].comment ? this.info[4].comment : '',

          Calories: this.info[0].calorie ? this.info[0].calorie : -1,
          Calories1: this.info[1].calorie ? this.info[1].calorie : -1,
          Calories2: this.info[2].calorie ? this.info[2].calorie : -1,
          Calories3: this.info[3].calorie ? this.info[3].calorie : -1,
          Calories4: this.info[4].calorie ? this.info[4].calorie : -1,

          PriceComment_SecondLang: this.AllowSecondLang && this.info[0].secondLangComment ? this.info[0].secondLangComment : '',
          Price1Comment_SecondLang: this.AllowSecondLang && this.info[1].secondLangComment ? this.info[1].secondLangComment : '',
          Price2Comment_SecondLang: this.AllowSecondLang && this.info[2].secondLangComment ? this.info[2].secondLangComment : '',
          Price3Comment_SecondLang: this.AllowSecondLang && this.info[3].secondLangComment ? this.info[3].secondLangComment : '',
          Price4Comment_SecondLang: this.AllowSecondLang && this.info[4].secondLangComment ? this.info[4].secondLangComment : ''
        }
        const model = Object.assign(base, priceInfo)
        model.Modifiers = model.Modifiers.map(item => item.ModifierCategoryID)
        model.SortOrder = [1]
        if(this.changedCategoryID != null)
          model.CategoryID = this.changedCategoryID
        model.Name_SecondLang = this.AllowSecondLang ? model.Name_SecondLang : ''
        model.sortOrder = this.allFoods.map(item => item.ID)
        model.ABV = model.Alcoholic && model.ABV ? model.ABV : -1
        if(this.model.ReferenceID){
          model.ReferenceID = this.model.ReferenceID
        }
        if(this.selectedTV === null || this.selectedTV === ""){
          if(this.item.MenuboardTVid !== null && this.item.MenuboardTVid !== 0){
            model.ShowOnTV = this.item.MenuboardTVid
          }else{
            model.ShowOnTV = 0
          }
        }else{
          let foundTV = this.TVrereferences.find(tv => tv.TVname === this.selectedTV)
          model.ShowOnTV = foundTV.TVid
        }
        if (proceed) {
          this.progressing = true
          return this.$api.foodDrink
            .update(model, this.item.ID, true)
            .then(() => {
              const isEditable = id => !this.inheritedLoyaltyRewardIds.includes(id)
              const rewardIds = this.selectedLoyaltyRewards.map(item => item.value).filter(isEditable)
              return this.syncLoyaltyRewards(this.item.ID, this.edibleType, rewardIds, this.initialLoyaltyRewardIds.filter(isEditable)).finally(() => {
                this.progressing = false
                this.modal = false
                this.$emit('refresh', this.category)
                this.$emit('refresh', this.availableCategories.find(el=>el.CategoryID === this.changedCategoryID))
              })
            })
            .catch(err => {
              this.progressing = false
              if (err.response.data) {
                this.$showError(err.response.data.Message)
              } else {
                this.$showError('error was occured')
              }
            })
        }
      })
      
    },
    deleteConfirmation() {
      this.$emit('deleteConfirmation')
    },
    down() {
      let fromIndex = this.allFoods.findIndex(item => item.ID === this.item.ID)
      if (fromIndex !== this.allFoods.length - 1) {
        const toIndex = fromIndex++
        const element = this.allFoods.splice(fromIndex, 1)[0]
        this.allFoods.splice(toIndex, 0, element)
      }
    },
    up() {
      let fromIndex = this.allFoods.findIndex(item => item.ID === this.item.ID)
      if (fromIndex !== 0) {
        const toIndex = fromIndex--
        const element = this.allFoods.splice(fromIndex, 1)[0]
        this.allFoods.splice(toIndex, 0, element)
      }
    }
  },
  computed: {
    modal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style scoped></style>
